import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 20px;
  background: var(--darkprimary-color);
`;

export const SectionTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: var(--white-color);
  text-align: center;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 35px;
  }
`;

export const StepsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 40px;
  max-width: 1000px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  max-width: 280px;
  position: relative;

  /* Linha conectora entre passos (só no desktop) */
  &:not(:last-child)::after {
    content: '→';
    position: absolute;
    right: -28px;
    top: 28px;
    font-size: 1.5rem;
    color: var(--primary-color);
    opacity: 0.5;

    @media (max-width: 768px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const StepNumber = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  font-size: 1.5rem;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  box-shadow: 0 4px 15px rgba(255, 153, 0, 0.4);
`;

export const StepIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 14px;
`;

export const StepTitle = styled.h3`
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--white-color);
  margin: 0 0 10px 0;
`;

export const StepDescription = styled.p`
  font-size: 0.95rem;
  color: #aaaaaa;
  line-height: 1.6;
  margin: 0;
`;
